import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AuthService implements CanActivate {

  private user: any = null;

  constructor(
    private router: Router,
    private http: HttpClient,
  ) {}

  login(username: string, password: string): Observable<any> {
    return this.http.post('/api/auth/login', {email: username, password: password});
  }

  profile(): Observable<any> {
    return this.http.get('/api/auth/logged-user').pipe(
      map((user: any) => {
        return user;
      })
    );
  }

  public isLoggedIn(): boolean {
    const token = localStorage.getItem('token');
    if (!token) {
      return false;
    }
    // @todo if token is invalid return false
    return true;
  }

  public logout(): void {
    this.http.delete('/api/auth/logout').subscribe((response: any) => {
      localStorage.removeItem('token');
      this.router.navigate(['/authentication/signin']);
    });

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.isLoggedIn()) {
      this.router.navigate(['authentication/signin']);
      return false;
    }

    return true;
  }
}
